import React, { useEffect, useState, useCallback, useRef } from 'react';
import { GoogleMap, Polyline, useJsApiLoader, DirectionsRenderer, DirectionsService } from '@react-google-maps/api';
import { Button, IconButton } from '@mui/material';
import blackcar from '../../assets/img/map_car_b.png';
import toll_start_icon from '../../assets/img/toll_start_icon.png';
import { baseURL } from '../base_url';
import { useSearchParams } from 'react-router-dom';
import { GrMapLocation } from "react-icons/gr";
import { GiPathDistance } from "react-icons/gi";
import { FaLocationArrow } from "react-icons/fa";
import moment from 'moment';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import { IoPrint } from "react-icons/io5";
import { RiScreenshot2Fill } from "react-icons/ri";
import html2canvas from 'html2canvas';
import { FaRoad } from "react-icons/fa6";
import { IoIosTime } from "react-icons/io";
import Select from "react-select";
import Swal from 'sweetalert2';
import CommentIcon from '@mui/icons-material/Comment';

const containerStyle = {
  width: '100%',
  height: '600px',
};

function TollsMap() {
    const [path, setPath] = useState([]);
    const [searchParams] = useSearchParams();
    
    const id = searchParams.get('id');
    const iid = searchParams.get('iid');
    const road = searchParams.get('road');
    const vin_search = searchParams.get('vin');

    const [marker, setMarker] = useState(null);
    const [vehiclePosition, setVehiclePosition] = useState(false);
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyC36o4niEA5vZG4bMS0CM5FBQaKEt6QADw', // Replace with your API key
    });
    const [selectedVehicle, setSelectedVehicle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [infoWindow, setInfoWindow] = useState(null); // State for InfoWindow instance
    const [center, setCenter] = useState({ lat: 28.449973, lng: -81.348195 });
    const [roadDistance, setRoadDistance] = useState(0);
    const [roadDuration, setRoadDuration] = useState(0);
    const [mapInstance, setMapInstance] = useState(null);
    const [directionsResponse, setDirectionsResponse] = useState(null);
    const [origin, setOrigin] = useState(null); // Example: start
    const [waypoints, setWaypoints] = useState(null); // Example: waypoints
    const [waypointsDistance, setWaypointsDistance] = useState(null); // Example: waypointsDistance
    const [destination, setDestination] = useState(null); // Example: end

    const [chargeOption, setChargeOption] = useState(null)
    const [chargeStatusButtonName, setChargeStatusButtonName] = useState('Close')
    const [isChargeButtonDisabled, setIsChargeButtonDisabled] = useState(false);
    const [chargeOptionDB, setChargeOptionFromDB] = useState('');
    const [chargeStatusOption, setChargeStatusOption] = useState([]);
    const [showInput, setInputField] = useState(false)
    const [amount, setAmount] = useState('0');
    const [amountDB, setAmountDB] = useState('0');
    const [showLabel, setShowLabel] = useState(false);
    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);
    const [adminAmount, setAdminAmount] = useState('0');

    const [showCommentModal, setShowCommentModal] = useState(false)
    const [currentAlertId, setCurrentAlertId] = useState(null);
    const [currentComment, setCurrentComment] = useState('');
    const [currentAgreementNumber, setCurrentAgreementNumber] = useState('');

    const rowRef = useRef(null); // Create a ref for the row div

    const handlePrint = () => {
        window.print();
    };

    const chargeStatusOptions = [
        { value: 'charge_at_counter', label: 'Charged At Counter' },
        { value: 'penalty_imposed', label: 'Penalty Imposed' },
        { value: 'pending', label: 'Pending' },
        { value: 'one_way', label: 'One-Way Rental' },
        { value: 'corporate', label: 'Corporate' },
        { value: 'governemnt_reservation', label: 'Government Reservation' },
        { value: 'wrong_alert', label: 'Wrong Alert' }
    ];

    const handleUnitType = (value, selected_unit) => {
        if(selected_unit == "Miles"){
            return (parseFloat(value) * 0.621371).toFixed(2)+" Miles";
        }else if(selected_unit == "Meter"){
            return (parseFloat(value) * 1000).toFixed(2)+" Meter";
        }else{
            return value+" km"
        }
    };

    const ConvertToTimeZone = (datetime, loc_id) => {
        const timezone = {
            '6': 'America/Denver',
            '20': 'America/Denver',
            '3': 'America/New_York',
            '5': 'America/New_York',
            '4': 'America/Chicago',
            '2': 'America/Toronto', 
            '1': 'America/Edmonton',
            '7': 'America/Vancouver',
            '9': 'America/Toronto',
            '8': 'America/Toronto',
            '12': 'America/Toronto',
            '21': 'Asia/Dubai',
            '22': 'America/Phoenix',
            '23': 'America/New_York'
        }
        const convertedTime = moment(datetime).tz(timezone[loc_id]).format('YYYY-MM-DD HH:mm:ss A');
        return convertedTime
    };

    const onCloseInfoWindow = () => {
        if (infoWindow) {
            infoWindow.close();
        }
    };

    useEffect(() => {
        setLoading(true);
        try {
            axios.get(baseURL + "/get_tolls_details_single?iid="+iid+"&id="+id+"&road="+road+"&vin="+vin_search).then((res_details) => {
                if(res_details.data.status === "1"){
                    const charge_type_options = res_details.data.data.charge_type_options
                    const mappedChargeStatusOption = charge_type_options.map(option => ({
                        value: option.value,
                        label: option.name
                    }));
                    setChargeStatusOption(mappedChargeStatusOption); // Store in state
                    setSelectedVehicle({"lat":res_details.data.data.vehicle[0].latitude,"lng":res_details.data.data.vehicle[0].longitude,"data":res_details.data.data,'loc_id': res_details.data.data.vehicle[0].loc_id,'rec_id': res_details.data.data.vehicle[0].current_alert_id});
                    setVehiclePosition(res_details.data.data)
                    setCurrentAlertId(res_details.data.data.current_alert_id)
                    setCurrentComment(res_details.data.data.current_comment)
                    setCurrentAgreementNumber(res_details.data.data.current_agreement_number)
        
                    const data2 = res_details.data.data.toll_road_coordinates;
                    const waypointschunks = [];
                    const waypointsdistance = [];
                    const vehicleArray = res_details.data.data.vehicle;
                    let lastVehicle = null;
                    // Handle the case when the array has only one record
                    if (vehicleArray.length == 1) {
                        if (vehicleArray[0].hasOwnProperty('charge_option') && vehicleArray[0].charge_option !== '') {
                            lastVehicle = vehicleArray[0];
                        }
                    } else {
                        // Use findIndex for arrays with multiple records
                        const lastVehicleIndex = vehicleArray.findIndex(vehicle => vehicle.hasOwnProperty('charge_option') && vehicle.charge_option !== '');
                        lastVehicle = lastVehicleIndex !== -1 ? vehicleArray[lastVehicleIndex] : null;
                    }
                    if(lastVehicle && lastVehicle.hasOwnProperty('charge_option') && lastVehicle.charge_option != '')
                    {
                        setChargeOption(lastVehicle.charge_option)
                        setChargeStatusButtonName(lastVehicle.charge_status)
                        setIsChargeButtonDisabled(true)
                        setChargeOptionFromDB(lastVehicle.charge_option)
                        setAmount(lastVehicle.charge_amount)
                        setAdminAmount(lastVehicle.admin_fees)
                        setAmountDB(lastVehicle.charge_amount)
                        if(lastVehicle.charge_option == "charge_at_counter" || lastVehicle.charge_option == "penalty_imposed")
                        {
                            setIsChargeButtonDisabled(false)
                            setInputField(true)
                            setShowLabel(true)
                        }
                    }
                    res_details.data.data.vehicle.forEach((latlong2, index2, array2) => {
                        if (index2 === 0 || index2 === array2.length - 1) {
                            if(index2 === 0){
                                setOrigin({ lat: latlong2.latitude, lng: latlong2.longitude })
                            }else{
                                setDestination({ lat: latlong2.latitude, lng: latlong2.longitude })
                            }
                        }else{
                            // waypointschunks.push({ location: { lat: latlong2.latitude, lng: latlong2.longitude }, stopover: true });
                            waypointsdistance.push({ lat: latlong2.latitude, lng: latlong2.longitude });
                        }
                    })

                    // Limit waypoints to 23 (Google API allows up to 25, including origin and destination)
                    const maxWaypoints = 23;
                    const step = Math.ceil(waypointsdistance.length / maxWaypoints);
                    for (let i = 0; i < waypointsdistance.length; i += step) {
                        waypointschunks.push({
                            location: waypointsdistance[i],
                            stopover: true
                        });
                    }
                    // setWaypoints(waypointschunks)
                    setWaypoints(waypointschunks.slice(0, maxWaypoints));
                    setWaypointsDistance(waypointsdistance)
                    try {
                        const maxPointsPerRequest = 100;
                        const snappedPoints = [];
                        for (let i = 0; i < data2.length; i += maxPointsPerRequest) {
                            const chunk = data2.slice(i, i + maxPointsPerRequest);
                            const snappedChunk = chunk.map((point) => ({
                                lat: point[0],  // Latitude
                                lng: point[1],  // Longitude
                            }));
                            snappedPoints.push(...snappedChunk);
                        }
                        setPath(snappedPoints);
                        
                    } catch (error) {
                        console.error('Error fetching road data:', error);
                    }
                }
            })
        } 
        catch (error) {
            // Handle errors here
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (mapInstance && vehiclePosition) {
            const bounds = new window.google.maps.LatLngBounds();
            const directionsService = new window.google.maps.DirectionsService();
            const distanceService = new window.google.maps.DistanceMatrixService();
            const waypointsPairs = [[origin, waypointsDistance[0]], ...waypointsDistance.map((wp, i) => [wp, waypointsDistance[i + 1] || destination])];
            vehiclePosition.vehicle.forEach((latlong, index, array) => {
                if (index === 0 || index === array.length - 1) {
                    bounds.extend(new window.google.maps.LatLng(latlong.latitude, latlong.longitude));
                    const iconUrl = index === 0 ? toll_start_icon : blackcar;
                    const marker = new window.google.maps.Marker({
                        position: { lat: latlong.latitude, lng: latlong.longitude },
                        map: mapInstance,
                        title: `VIN: ${vehiclePosition.vin}`,
                        icon: {
                            url: iconUrl,
                            scaledSize: new window.google.maps.Size(25, 25),
                        },
                    });
                    setMarker(marker);
                    marker.addListener('click', () => {
                        const contentString = `
                            <div>
                                <p><b>VIN:</b> ${vehiclePosition.vin}</p>
                                <p><b>Speed:</b> ${latlong.response_data.speed.value} km/h</p>
                                <p><b>Odometer:</b> ${latlong.response_data.odometer.value} km</p>
                                <p><b>Fuel Level:</b> ${(latlong.response_data.fuel.level.value) ? (latlong.response_data.fuel.level.value) + ' L' : (latlong.response_data.fuel.level.percentage) + ' %'}</p>
                                <p><b>Last DateTime:</b> ${latlong.response_data.datetime}</p>
                            </div>
                        `;
                        const newInfoWindow = new window.google.maps.InfoWindow({
                            content: contentString,
                        });
                        newInfoWindow.open(mapInstance, marker);
                        setInfoWindow(newInfoWindow);
                    });
                }
            });
            
            directionsService.route(
                {
                    origin: origin,
                    destination: destination,
                    waypoints: waypoints, // Add waypoints here
                    travelMode: window.google.maps.TravelMode.DRIVING,
                },
                (result, status) => {
                    if (status === window.google.maps.DirectionsStatus.OK) {
                    setDirectionsResponse(result);
                    } else {
                    console.error(`Error fetching directions ${status}`);
                    }
                }
            );
            
            distanceService.getDistanceMatrix(
                {
                origins: [origin],
                destinations: [destination],
                travelMode: window.google.maps.TravelMode.DRIVING,
                },
                (response, status) => {
                if (status === window.google.maps.DistanceMatrixStatus.OK) {
                    const result = response.rows[0].elements[0];
                    if (result) {
                        setRoadDistance(result.distance.text);
                        setRoadDuration(result.duration.text);
                    }
                } else {
                    console.error(`Error fetching distance ${status}`);
                }
                }
            );
            mapInstance.fitBounds(bounds);
            setCenter(bounds.getCenter().toJSON());
        }
    }, [mapInstance, vehiclePosition]);
    
    const onLoad = useCallback((map) => {
        setMapInstance(map); // Store the map instance when it loads
    }, []);

    useEffect(() => {
        // Update the marker position when the vehicle position changes
        if (marker) {
            marker.setPosition(vehiclePosition);
        }
    }, [vehiclePosition, marker]);

    if (loadError) {
        return <div>Error loading maps</div>;
    }

    if (!isLoaded) {
        return <div>Loading Maps...</div>;
    }

    const polylineOptions = {
        strokeColor: '#0000FF', // Blue color
        strokeOpacity: 0.7,
        strokeWeight: 3,
    };
    //screenshort function   
    const handleScreenshot = async () => {
        const agreementNumber = selectedVehicle.data.agreement_number
        const rowElement = rowRef.current;
        html2canvas(rowElement, {
            useCORS: true,
            scrollX: 0,
            scrollY: 0,
            windowWidth: document.documentElement.offsetWidth,
            windowHeight: document.documentElement.offsetHeight,
            x: rowElement.scrollLeft,
            y: rowElement.scrollTop,
            width: rowElement.offsetWidth,
            height: rowElement.offsetHeight,
        }).then(rowCanvas => {
            const combinedCanvas = document.createElement('canvas');
            const context = combinedCanvas.getContext('2d');
  
            // Set canvas dimensions to accommodate map and row div
            combinedCanvas.width = rowCanvas.width;
            combinedCanvas.height = rowCanvas.height; // Adjust as needed
  
            // Draw the row div canvas onto the combined canvas
            context.drawImage(rowCanvas, 0, 0);
  
            // Draw the map canvas onto the combined canvas below the row div
            context.drawImage(rowCanvas, 0, rowCanvas.height);
            
            // Convert combined canvas to a data URL
            const url = combinedCanvas.toDataURL();
  
            // Create a temporary link element
            const link = document.createElement('a');
            link.href = url;
            link.download = `${agreementNumber}.png`; // Set the filename for the downloaded file
  
            // Append the link to the document body and trigger a click
            document.body.appendChild(link);
            link.click();
  
            // Clean up by removing the link from the document body
            document.body.removeChild(link);
        });
    };

    const handleInputClick = (alertId, comment_text, agreement_number, e) => {
        if (!alertId) {
            console.error("Invalid alertId:", alertId);
            Swal.fire('Error', 'Cannot open comment modal: Missing alert ID.', 'error');
            return;
        }
    
        setCurrentAlertId(alertId);
        setCurrentComment(comment_text || "");
        setCurrentAgreementNumber(agreement_number || "");
        setShowCommentModal(true);
    };

    const handleChargeOption = (selectedOption) => {
        if(chargeOptionDB != selectedOption.value)
        {
            if(selectedOption.value == "charge_at_counter" || selectedOption.value == "penalty_imposed")
            {
                setChargeStatusButtonName('Close')
                setInputField(true)
                setShowLabel(true)
                setIsChargeButtonDisabled(true)
            }
            else if(selectedOption.value == "pending")
            {
                setChargeStatusButtonName('Submit')
                setInputField(false)
                setShowLabel(false)
                setAmount("0")
                setAdminAmount("0")
                setIsChargeButtonDisabled(false)
            }
            else
            {
                setChargeStatusButtonName('Close')
                setInputField(false)
                setShowLabel(false)
                setAmount("0")
                setAdminAmount("0")
                setIsChargeButtonDisabled(false)
            }
            
        }
        else
        {
            if(chargeOptionDB == "charge_at_counter" || chargeOptionDB == "penalty_imposed")
            {
                setChargeStatusButtonName('Close')
                setInputField(true)
                setShowLabel(true)
                setIsChargeButtonDisabled(true)
            }
            else if(chargeOptionDB == "pending")
            {
                setChargeStatusButtonName('Submit')
                setInputField(false)
                setShowLabel(false)
                setIsChargeButtonDisabled(false)
            }
            else
            {
                setIsChargeButtonDisabled(true)
                setInputField(false)
                setShowLabel(false)
                setChargeStatusButtonName('Closed')
            }
        }
        setChargeOption(selectedOption.value)
    }

    const handleSaveComment = async () => {
        // Prepare payload
        const payload = {
            id: currentAlertId,
            comment: currentComment,
            agreement_number: currentAgreementNumber,
            admin_id: foundUser['tm_id']
        };
    
        try {
    
            const response = await axios.post(`${baseURL}/update_comment_for_tolls`, payload);
    
            // Check if response data is an array
            if (Array.isArray(response.data)) {
                const firstResponse = response.data[0]; // Assuming success/error is in the first element
    
                if (firstResponse && firstResponse.success === "Document inserted") {
                    Swal.fire('Updated', 'Comment Updated', 'success');
                } else if (firstResponse && firstResponse.success === "Document updated/inserted") {
                    Swal.fire('Updated', 'Comment Updated or Inserted', 'success');
                } else {
                    Swal.fire('Failed', firstResponse.error || 'Something went wrong.', 'error');
                }
            } else {
                Swal.fire('Failed', 'Unexpected response format.', 'error');
            }
        } catch (error) {
            console.error("Error while updating comment:", error);
    
            // Show error feedback to the user
            Swal.fire('Error', 'Failed to update comment. Please try again later.', 'error');
        } finally {
            // Close the modal and refresh the page
            setShowCommentModal(false);
            window.location.reload();
        }
    };

    const handleInputChange = (event) => {
        let entered_amount = event.target.value;
        if(amountDB == entered_amount)
        {
            setAmount(entered_amount);
            setIsChargeButtonDisabled(true)
        }
        else{
            setAmount(entered_amount);
            setIsChargeButtonDisabled(false)
        }
    };

    const handleAdminAmountChange = (event) => {
        let entered_amount = event.target.value;
        setAdminAmount(entered_amount);
    };

    const handleChargeStatus = () => {
        axios.post(baseURL+"/update_toll_charge",{
        rec_id: selectedVehicle.rec_id,
        chargeOption:chargeOption,
        chargeAmount:amount,
        adminAmount:adminAmount,
        agreementNumber: selectedVehicle.data.agreement_number,
        vin: selectedVehicle.data.vin,
        admin_id: foundUser['tm_id']
        }).then((res) => 
        {
            if(res.data.success === 'success'){
                setChargeStatusButtonName(res.data.charge_status)
                setIsChargeButtonDisabled(true);
                Swal.fire('Updated', 'Charge Status Updated', 'success')
            }else{
                Swal.fire("Something went wrong.")
            }
        })
    }

    
    return (
        <div>
            {loading ? (
                <div className="loader-overlay">
                    <div className="loader">
                        <PuffLoader color="#00308F" loading={true} size={200} />
                    </div>
                </div>
            ) : ("")}
            <div style={{ display: "flex", justifyContent: "left", padding:"7px",marginLeft:"25px"}}>
                <Button size='small' variant="contained" onClick={handlePrint}><IoPrint size={25}/>&nbsp;Print Full Page</Button>&nbsp;&nbsp;
                <Select
                value={chargeStatusOption.find(option => option.value === chargeOption)}
                getOptionLabel={option => option.label}
                getOptionValue={option => option.value}
                name="chargeOption"
                options={chargeStatusOption}
                onChange={handleChargeOption}
                placeholder="Select Charge Status"
                className="fixed-size-select" />
                &nbsp;&nbsp;
                { showInput &&
                    <input
                        type="number"
                        value={amount}
                        onChange={handleInputChange}
                        className="number-input"
                    />
                }
                &nbsp;&nbsp;
                { showInput &&
                    <input
                        type="number"
                        value={adminAmount}
                        onChange={handleAdminAmountChange}
                        className="number-input"
                        // style={{ border: "1px solid green" }}
                    />
                }
                &nbsp;&nbsp;
                <Button size='small' variant="contained" 
                    onClick={handleChargeStatus} disabled={isChargeButtonDisabled} 
                    style={isChargeButtonDisabled ? { color: 'black', fontWeight: 'bold' } : {}}>{chargeStatusButtonName}
                </Button>
                &nbsp;&nbsp;
                <IconButton
                    size="small"
                    onClick={(e) =>
                        handleInputClick(
                            selectedVehicle?.data?.current_alert_id,
                            selectedVehicle?.data?.current_comment || "",
                            selectedVehicle?.data?.agreement_number || "",
                            e
                        )
                    }
                    variant="contained"
                >
                    <CommentIcon style={{ color: 'blue' }} />
                </IconButton>
                {showLabel && 
                    <label style={{fontSize:"16px",color:"red"}}>***Please enter the admin fees without tax***</label>
                }

                {showCommentModal && currentAlertId !== null && (
                    <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                        {/* style={{backgroundColor:"#254465",color:"white"}} */}
                        <div className="modal-header"> 
                            <h5 className="modal-title" >Add/Update Comment for {currentAgreementNumber}</h5>
                            <button type="button" className="btn-close" onClick={() => setShowCommentModal(false)} aria-label="Close"></button>
                        </div> 
                        <div className="modal-body">
                            <textarea value={currentComment} onChange={(e) => setCurrentComment(e.target.value)} rows="4" cols="50" />
                        </div>
                        <div className="modal-footer">
                            {/* <Button variant="secondary" onClick={() => setShowCommentModal(false)}>Close</Button> */}
                            <Button variant="contained" onClick={handleSaveComment}>Save changes</Button>
                        </div>
                        </div>
                    </div>
                    </div>
                )}
            </div>
            <div style={{ display: "flex", justifyContent: "right", marginTop:"-44px", padding:"7px",marginRight:"65px"}}><Button size='small' variant="contained" onClick={handleScreenshot}><RiScreenshot2Fill size={25}/>&nbsp;Take Screenshot</Button></div>
            <div className='row' ref={rowRef}>
            {selectedVehicle ? (
                <div className='col-3 car_details' style={{maxHeight:"83vh",overflowY:"auto",paddingLeft:"25px"}}>
                    <div className='row'>
                        <div className='col-12'>
                            <div className="reverse-pentagon">
                                <div className="reverse-pentagon-inner">
                                    <strong><FaRoad /></strong><br/>
                                    <strong>{selectedVehicle.data.road_number}</strong>
                                </div>
                            </div>
                            <div><lable className="fw-bold">Make Model : </lable>{selectedVehicle.data.make} {selectedVehicle.data.model}</div>
                            <div><lable className="fw-bold">Vin : </lable>{selectedVehicle.data.vin}</div>
                            <div><lable className="fw-bold">Plate : </lable>{selectedVehicle.data.plate}</div>
                            {selectedVehicle.data.agreement_number ? (
                                <div><lable className="fw-bold">R/A : </lable>{selectedVehicle.data.agreement_number}</div>
                            ) : (<div></div>)}
                            
                            <div style={{color:selectedVehicle.data.agreement_status === 'In Agreement'?'green':'grey',float:"right"}}><lable className="fw-bold">{selectedVehicle.data.agreement_status}</lable></div>
                        </div>
                    </div>
                    {/* <hr className='hr_alert'/> */}
                    {/* <div className='row'>
                        <div className='col-8'>
                            <p className="fw-bold" style={{marginBlock:"1px"}}><GiPathDistance /> Distance</p>
                        </div>
                        <div className='col-12'><span style={{marginLeft:"15px"}}><b style={{fontSize:"13"}}> {(roadDistance)?handleUnitType(roadDistance, selectedVehicle.data.unit_type):0}</b></span></div>
                    </div>
                    <hr className='hr_alert'/>
                    <div className='row'>
                        <div className='col-8'>
                            <p className="fw-bold" style={{marginBlock:"1px"}}><IoIosTime /> Duration</p>
                        </div>
                        <div className='col-12'><span style={{marginLeft:"15px"}}><b style={{fontSize:"13"}}> {(roadDuration)?roadDuration:0}</b></span></div>
                    </div> */}
                    {/* <hr className='hr_alert'/>
                    <div className='row'>
                        <div className='col-12'>
                            <p className="fw-bold" style={{marginBlock:"1px"}}><img src={toll_start_icon} width={20}/> Start Point</p>
                        </div>
                        <div className='col-12'><span style={{marginLeft:"15px"}}><b style={{fontSize:"13"}}> {selectedVehicle.data.vehicle[0].road_address}</b></span></div>
                        <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Date: <b style={{color:"#eb6834"}}> {(selectedVehicle.data.vehicle[0].response_data)?ConvertToTimeZone(selectedVehicle.data.vehicle[0].response_data.datetime, selectedVehicle.loc_id):""} </b></div>
                        <div className='col-12'>
                            <p className="fw-bold" style={{marginBlock:"1px"}}><img src={blackcar} width={20}/> End Point</p>
                        </div>
                        <div className='col-12'><span style={{marginLeft:"15px"}}><b style={{fontSize:"13"}}> {selectedVehicle.data.vehicle[selectedVehicle.data.vehicle.length -1].road_address}</b></span></div>
                        <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Date: <b style={{color:"#eb6834"}}> {(selectedVehicle.data.vehicle[selectedVehicle.data.vehicle.length -1].response_data)?ConvertToTimeZone(selectedVehicle.data.vehicle[selectedVehicle.data.vehicle.length -1].response_data.datetime, selectedVehicle.loc_id):""} </b></div>
                    </div> */}
                    <hr className='hr_alert'/>
                    <div className='row'>
                        <div className='col-8'>
                            <p className="fw-bold"><GrMapLocation /> Location Info</p>
                        </div>
                        <ul className="styled-list">
                            {selectedVehicle.data.vehicle.map((item, index) => (
                                <li key={index} className="styled-item">
                                    <div className='col-12'><span style={{marginLeft:"15px"}}><FaLocationArrow /> {item.road_address}</span></div>
                                    <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Date: <b style={{color:"#eb6834"}}> {(item.response_data)?ConvertToTimeZone(item.response_data.datetime, selectedVehicle.loc_id):""} </b></div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <label className='mt-5' style={{float:"right"}}><i>Last Updated: <span style={{color:"red"}}>{moment(selectedVehicle.data.vehicle[0].response_data.datetime).tz("US/Eastern").format("MM/DD/YYYY HH:mm")} EST</span></i></label>
                        </div>
                    </div>
                </div>
                ) : (
                    <div>Loading...</div>
                )}
                <div className='col-9'>
                    { isLoaded ? (
                        <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={center}
                            zoom={12}
                            onLoad={onLoad}
                            onClick={onCloseInfoWindow}
                            >
                            {path.length > 0 && <Polyline path={path} options={polylineOptions} />}
                            {/* {vehiclePath.length > 0 && <Polyline path={vehiclePath} options={vehiclePolylineOptions} />} */}
                            {directionsResponse && ( <DirectionsRenderer directions={directionsResponse} options={{
                                                                                                                    polylineOptions: {
                                                                                                                    strokeColor: "#FF0000", // Custom color for the route
                                                                                                                    strokeOpacity: 1.0,
                                                                                                                    strokeWeight: 8,
                                                                                                                    },
                                                                                                                    suppressMarkers: true, // Suppress default markers
                                                                                                                }}/> )}
                        </GoogleMap>
                    ) : (<div>Loading...</div>) }
                </div>
            </div>
        </div>
    );
}

export default TollsMap;